
import ShopifyProduct from "./ShopifyProduct";

export default  {
    categories: [
        { name: 'Hidden', handle: 'hidden', subcategories: []},
        { name: 'Dresses', handle: 'dresses', subcategories: [
            { name : 'Mini Dresses', handle: 'mini-dresses' },
            { name : 'Midi Dresses', handle: 'midi-dresses' },
            { name : 'Maxi Dresses', handle: 'maxi-dresses' },
            { name : 'Gowns', handle: 'gowns' },
            { name : 'Bride', handle: 'bride' },
        ]},
        { name: 'Skirts', handle: 'skirts', subcategories: [
            { name : 'Mini Skirts', handle: 'mini-skirts' },
            { name : 'Midi Skirts', handle: 'midi-skirts' },
            { name : 'Maxi Skirts', handle: 'maxi-skirts' },
        ]},
        { name: 'Tops', handle: 'tops', subcategories: [
            { name : 'Sleeveless Tops', handle: 'short-sleeve-tops' },
            { name : 'Short Sleeve Tops', handle: 'short-sleeve-tops' },
            { name : 'Long Sleeve Tops', handle: 'long-sleeve-tops' },
            { name : 'Crop Tops', handle: 'crop-tops' },
            { name : 'Tees', handle: 'tees' },
            { name : 'Shirts', handle: 'shirts' }
        ]},
        { name: 'Bottoms', handle: 'bottoms', subcategories: [
            { name : 'Shorts', handle: 'shorts'},
            { name : 'Cropped Pants', handle: 'cropped-pants'},
            { name : 'Jeans', handle: 'jeans'},
            { name : 'Dress Pants', handle: 'dress-pants'},
            { name : 'Skinny Pants', handle: 'skinny-pants' },
            { name : 'Wide Leg & Flare Pants', handle: 'wide-leg-and-flare-pants' },
            { name : 'Leggings', handle: 'leggings' },
        ]},
        { name: 'Overalls', handle: 'overalls', subcategories: [
            ]},
        { name: 'Knitwear', handle: 'knitwear', subcategories: [
            { name : 'Sweaters', handle: 'sweaters' },
            { name : 'Cardigans', handle: 'cardigans' },
        ]},
        { name: 'Jumpsuits', handle: 'jumpsuits-and-rompers', subcategories: [
            { name : 'Playsuits', handle: 'playsuits' },
            { name : 'Jumpsuits', handle: 'jumpsuits' }
        ]},

        { name: 'Coats & Jackets', handle: 'coats-and-jackets', subcategories: [
            { name : 'Casual Jackets', handle: 'casual-jackets' },
            { name : 'Bomber & Puffer Jackets', handle: 'bomber-and-puffer-jackets' },
            { name : 'Smart Jackets', handle: 'smart-jackets' },
            { name : 'Blazer Jackets', handle: 'blazer-jackets' },
            { name : 'Coats', handle: 'coats' },
        ]},
        { name: 'Loungewear & Activewear', handle: 'loungewear-and-activewear', subcategories: [
            { name : 'Bike Shorts', handle: 'bike-shorts' },
            { name : 'Tights', handle: 'tights' },
            { name : 'Sports Bras', handle: 'sports-bras' },
            { name : 'Tank Tops', handle: 'tank-tops' },
            { name : 'Sweat Shirts', handle: 'sweat-shirts' },
            { name : 'Sweat Pants', handle: 'sweat-pants' },
            { name : 'Leggings', handle: 'leggings' },
            { name : 'Jumpers', handle: 'jumpers' },
            { name : 'Hoodies', handle: 'hoodies' },
        ]},
        { name: 'Intimates', handle: 'intimates', subcategories: [
            { name : 'Bras', handle: 'bras' },
            { name : 'Bralettes', handle: 'bralettes' },
            { name : 'Briefs', handle: 'briefs' },
        ]},

        { name: 'Swimwear', handle: 'swimwear', subcategories: [
            { name : 'Swim Tops', handle: 'swim-tops' },
            { name : 'Swim Bottoms', handle: 'swim-bottoms' },
            { name : 'Swim Sets', handle: 'swim-sets' },
            { name : 'Swim One Piece', handle: 'swim-one-piece' }
        ]},
        { name: 'Robes & Kikomos', handle: 'robes-and-kikomos', subcategories: [
            ]},
        { name: 'Shoes', handle: 'shoes', subcategories: [
                { name : 'Boots', handle: 'boots' },
                { name : 'Heels', handle: 'heels' },
                { name : 'Flat Shoes', handle: 'flat-shoes' },
                { name : 'Sneakers', handle: 'sneakers' },
                { name : 'Sandals', handle: 'sandals' },
                { name : 'Slip Ons', handle: 'slip-ons' },
            ]},
        { name: 'Accessories', handle: 'accessories', subcategories: [
            { name : 'Belts', handle: 'belts' },
            { name : 'Sunglasses', handle: 'sunglasses' },
            { name : 'Hats', handle: 'hats' },
            { name : 'Bags', handle: 'bags' }
        ]}
        //,
        //{ name: 'Miscellaneous', handle: 'miscellaneous', subcategories: []}

    ],


    matches: [
        { match: 'pre-loved', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'preloved', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'secondhand', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'second hand', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'earring', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'necklace', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'perfume', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'fragrance', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'towel', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'pajama', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'pyjama', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },

        { match: "tank top", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "tanktop", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "singlet", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "cami", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "tee ", category: 'Tops', subcategory: 'Tees', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "t-shirt", category: 'Tops', subcategory: 'Tees', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "tshirt", category: 'Tops', subcategory: 'Tees', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'jumpsuit', category: 'Jumpsuits', subcategory: 'Jumpsuits', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'playsuit', category: 'Jumpsuits', subcategory: 'Playsuits', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'romper', category: 'Jumpsuits', subcategory: 'Playsuits', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "mini dress", category: 'Dresses', subcategory: 'Mini Dresses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "midi dress", category: 'Dresses', subcategory: 'Midi Dresses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "maxi dress", category: 'Dresses', subcategory: 'Maxi Dresses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "mini skirt", category: 'Skirts', subcategory: 'Mini Skirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "midi skirt", category: 'Skirts', subcategory: 'Midi Skirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "maxi skirt", category: 'Skirts', subcategory: 'Maxi Skirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "shorts", category: 'Bottoms', subcategory: 'Shorts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "wide-leg", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "wideleg", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "flare pant", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "wide leg", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "overall", category: 'Overalls', subcategory: 'Overalls', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'coat', category: 'Coats & Jackets', subcategory: 'Coats', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bomber jacket', category: 'Coats & Jackets', subcategory: 'Bomber & Puffer Jackets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'blazer', category: 'Coats & Jackets', subcategory: 'Blazer Jackets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'cardigan', category: 'Knitwear', subcategory: 'Cardigans', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweater', category: 'Knitwear', subcategory: 'Sweaters', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'boot', category: 'Shoes', subcategory:'Boots', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'heel', category: 'Shoes', subcategory: 'Heels', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sneaker', category: 'Shoes', subcategory: 'Sneakers', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sandal', category: 'Shoes', subcategory: 'Sandals', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweat shirt', category: 'Loungewear & Activewear', subcategory: 'Sweat Shirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweatshirt', category: 'Loungewear & Activewear', subcategory: 'Sweat Shirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweatpant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweat pant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'trackpant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'track pant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'hoodie', category: 'Loungewear & Activewear', subcategory: 'Hoodies', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'hoody', category: 'Loungewear & Activewear', subcategory: 'Hoodies', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'jumper', category: 'Loungewear & Activewear', subcategory: 'Jumpers', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'legging', category: 'Loungewear & Activewear', subcategory: 'Leggings', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'thong', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim bottom', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bikini bottom', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim top', category: 'Swimwear', subcategory: 'Swim Top', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bikini top', category: 'Swimwear', subcategory: 'Swim Top', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim set', category: 'Swimwear', subcategory: 'Swim Sets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bikini set', category: 'Swimwear', subcategory: 'Swim Sets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim onepiece', category: 'Swimwear', subcategory: 'Swim One Piece', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim one piece', category: 'Swimwear', subcategory: 'Swim One Piece', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'kikomo', category: 'Robes & Kikomos', subcategory: 'Robes & Kikomos', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sunglasses', category: 'Accessories', subcategory: 'Sunglasses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE }
    ],

    findMatch(product_name){
        return this.matches.find( u => product_name.toLowerCase().includes(u.match));
    },

    nameToHandle(name){
        return name.toLowerCase().replace(' & ', '-and-').trim().replace(/ /g,'-');
    },

    handleToName(handle){
        return handle.toLowerCase().replace('-and-', ' & ').trim().replace(/-/g,' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());
    },

    validateCategories() {
        for (let category of this.categories) {
            let handle = this.nameToHandle(category.name);
            if (handle !== category.handle){
                console.log(handle + ' !== ' + category.handle)
                return false;
            }
            if (category.name !== this.handleToName(category.handle)){
                console.log(category.name  + ' !== ' + this.handleToName(category.handle));
                return false;
            }

            for (let subcategory of category.subcategories) {
                let handle = this.nameToHandle(subcategory.name);
                if (handle !== subcategory.handle){
                    console.log(handle + ' !== ' + subcategory.handle)
                    return false;
                }
                if (subcategory.name !== this.handleToName(subcategory.handle)){
                    console.log(subcategory.name  + ' !== ' + this.handleToName(subcategory.handle));
                    return false;
                }
            }
        }
        return true;
    },

    isParentCategory(category_name){
        console.log("is", category_name)
      return this.categories.some(c => c.name === category_name);
    },

    toFlatArray(){
       let result = this.categories.reduce((output, category) =>{
            output.push({ title: category.name, category: category.name, subcategory: category.name, });
            for(let subcategory of category.subcategories){
                output.push({ title: `${category.name} - ${subcategory.name}`, category: category.name, subcategory: subcategory.name });
            }
            return output;
        }, []);
       result.push({ title: '', category: null, subcategory: null });
       return result;
    },

    toIndentedFlatArray(){
        let result = this.categories.reduce((output, category) =>{
            output.push({ title: category.name, category: category.name, subcategory: category.name, is_subcategory: false });
            for(let subcategory of category.subcategories){
                output.push({ title: `${category.name} - ${subcategory.name}`, category: category.name, subcategory: subcategory.name, is_subcategory: true  });
            }
            return output;
        }, []);
        result.push({ title: '', category: null, subcategory: null });
        return result;
    }
}